<template>
  <div class="NewCenter">
    <!-- banner start -->
    <div class="News-bannerbox">
      <div class="News-bannerbox-content">
        <p class="Newsbox-contentname">新闻中心</p>
        <p class="Newsbannerbox-contenttext">
          我想成为一个追求社会和人力资源可持续发展的探索者， 这样即使100年之后，这种爱也可以实现。
        </p>
      </div>
    </div>
    <!-- banner end -->
    <!-- newscontent start -->
    <div class="news-contant">
      <p class="news-titel">新闻中心</p>
      <p class="news-titelNEWS">NEWS</p>
      <p class="all-news">所有新闻</p>
      <el-divider></el-divider>
      <el-row class="newsitem-box" v-for="(item,index) in NewList" :key='item.index'>
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
          <div class="news-imgbox">
            <img :src= "item.picture" />
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
          <p class="time">{{item.ctime}}</p>
          <p class="title">{{item.name}}</p>
          <p class="coendncent-news">{{item.description}}</p>
        </el-col>
      </el-row>
      <!-- 分页start -->
      <el-pagination background layout="prev, pager, next" :total="10" class="paging"></el-pagination>
      <!-- 分页  -->
    </div>
    <!-- newscontent end -->
    <!-- 底部引入 -->
    <FooderContent></FooderContent>
  </div>
</template>

<script>
  import FooderContent from '../components/fooder.vue'
  import {Newslist} from '../../api/index.js'
  import {url} from '../../config/config.js'
  export default {
    components: {
      FooderContent
    },
    created(){
      //新闻
      Newslist().then(res=>{
        res.data.data.map(item=>{
          item.picture = url + item.picture
        })
        this.NewList=res.data.data
        console.log(this.NewList)
      })
      .catch(err=>{
        alert('错误信息'+err.msg)
      })
    },
    data() {
      return {
        newlist: [],
        NewList:[],
      }
    }
  }
</script>

<style scoped="scoped">
  /* banner start */
.News-bannerbox {
	width: 100%;
	min-width: 118rem;
	height: 21.875rem;
	background-image: url(../assets/news-image/newsbanner.jpg);
	background-size: 100% 100%
}

.News-bannerbox-content {
	width: 21.875rem;
	overflow: auto;
	padding-top: 8.125rem;
	padding-left: 22.5rem
}

.Newsbox-contentname {
	font-size: 1.875rem;
	font-family: Source Han Sans SC;
	color: #fff;
	margin-bottom: 20px
}

.Newsbannerbox-contenttext {
	font-size: .875rem;
	font-family: Source Han Sans SC;
	font-weight: 400;
	color: #fff;
	opacity: 1;
	margin: 0
}

  /* bannet end */
  /* newscontent start */
.news-contant {
	width: 80%;
	overflow: auto;
	margin: 6.25rem auto 0
}

.news-titel {
	font-size: 2.25rem;
	font-family: SourceHanSansSC-Medium;
	line-height: 54px;
	margin-bottom: 0
}

.news-titelNEWS {
	width: 9rem;
	border-bottom: .125rem solid #39ab6d;
	margin-top: .6875rem;
	padding-bottom: .6875rem;
	color: #999
}

.all-news {
	font-size: 23px;
	font-family: Source Han Sans SC;
	color: #666;
	font-weight: 400;
	margin-top: 3.125rem
}

.news-imgbox {
	width: 17.1875rem;
	height: 10.9375rem;
	border: 1px dashed #fff;
	background-size: 100% 100%;
	margin: 2.375rem auto;
	overflow: hidden
}

.news-imgbox :hover {
	cursor: default;
	-webkit-transform: scale(1.2);
	transform: scale(1.2);
	-webkit-transition: all .4s linear;
	transition: all .4s linear
}

.NewCenter .el-col :hover {
	-webkit-transform: translateY(-7px);
	transform: translateY(-7px);
	-webkit-transition: -webkit-transform .4s;
	transition: -webkit-transform .4s;
	transition: transform .4s;
	transition: transform .4s, -webkit-transform .4s
}

.news-imgbox img {
	width: 100%;
	height: 100%
}

.time {
	color: #999;
	margin-top: 2.375rem;
	margin-bottom: .3125rem
}

.title {
	color: #333;
	margin-bottom: 2.75rem
}

.coendncent-news {
	color: #666
}

  /* newscontent end */
  /* paging start */
.paging {
	text-align: center;
	margin: 3.75rem auto !important
}

.el-pagination.is-background .el-pager li:not(.disabled) {
	background-color: #fff !important;
	color: #39ab6d !important
}

.el-pagination.is-background .el-pager li:not(.disabled).active,
.el-pagination.is-background .el-pager li:not(.disabled):hover {
	background-color: #39ab6d !important;
	color: #fff !important
}

.newsitem-box el-row {
	border-top: 1px solid #000
}


  @media screen and (max-width: 100rem) {

    /* banner start */
    .News-bannerbox {
    	width: 100%;
    	min-width: 118rem;
    	height: 21.875rem !important;
    	background-image: url(../assets/news-image/newsbanner.jpg);
    	background-size: 100% 100%
    }

    .News-bannerbox-content {
    	width: 21.875rem;
    	overflow: auto;
    	padding-top: 8.125rem;
    	padding-left: 22.5rem
    }

    .Newsbox-contentname {
    	font-size: 1.875rem;
    	font-family: Source Han Sans SC;
    	color: #fff;
    	margin-bottom: 20px
    }

    .Newsbannerbox-contenttext {
    	font-size: .875rem;
    	font-family: Source Han Sans SC;
    	font-weight: 400;
    	color: #fff;
    	opacity: 1;
    	margin: 0
    }

    .news-titel {
    	font-size: 2.25rem;
    	font-family: SourceHanSansSC-Medium;
    	line-height: 54px;
    	margin-bottom: 0;
    	margin-top: 6.25rem
    }

    .news-titelNEWS {
    	width: 9rem;
    	border-bottom: .125rem solid #39ab6d;
    	margin-top: .6875rem;
    	padding-bottom: .6875rem;
    	color: #999
    }

    .all-news {
    	font-size: 23px;
    	font-family: Source Han Sans SC;
    	color: #666;
    	font-weight: 400;
    	margin-top: 3.125rem
    }

    .el-divider--horizontal {
    	display: block;
    	height: 1px;
    	width: 100%;
    	margin: 24px 0
    }

    .news-imgbox {
    	margin: 10px auto
    }

    .time {
    	margin-top: 0;
    	font-size: .625rem
    }

    .title {
    	font-size: 1rem;
    	margin: .5rem 0 2.75rem
    }

    .coendncent-news {
    	font-size: .625rem
    }

    .news-contant {
    	width: 80%;
    	min-width: 100rem;
    	overflow: auto;
    	margin: 0 auto 0 6.25rem
    }
  }

  @media screen and (max-width: 62rem) {

    /* banner start */
    .News-bannerbox {
    	width: 100%;
    	min-width: 100%;
    	height: 10.875rem !important;
    	background-image: url(../assets/news-image/newsbanner.jpg);
    	background-size: 100% 100%
    }

    .News-bannerbox-content {
    	width: 17rem !important;
    	overflow: auto;
    	padding-top: 4rem !important;
    	padding-left: 8rem !important
    }

    .Newsbox-contentname {
    	font-size: 1rem;
    	margin-bottom: .5rem;
    	font-family: Source Han Sans SC;
    	color: #fff
    }

    .Newsbannerbox-contenttext {
    	font-size: .1rem;
    	font-family: Source Han Sans SC;
    	font-weight: 400;
    	color: #fff;
    	opacity: 1
    }

    .news-titel {
    	font-size: 1.1rem;
    	margin-top: 0;
    	margin-left: 10px
    }

    .news-titelNEWS {
    	font-size: .1rem !important;
    	border-bottom: .1rem solid #39ab6d;
    	margin-top: 0;
    	width: 4rem;
    	padding-bottom: .3rem;
    	color: #999;
    	margin-left: 10px
    }

    .all-news {
    	font-size: .8rem;
    	font-family: Source Han Sans SC;
    	color: #666;
    	margin-left: 10px
    }

    .el-divider--horizontal {
    	display: block;
    	height: 1px;
    	width: 97%;
    	margin: 24px 12px
    }

    .news-imgbox {
    	margin: 10px auto
    }

    .time {
    	margin-top: 0;
    	font-size: .625rem;
    	margin-left: 10px
    }

    .title {
    	font-size: 1rem;
    	margin: .5rem 0 1.5rem 10px
    }

    .coendncent-news {
    	font-size: .625rem;
    	margin: 0 45px
    }

    .news-contant {
    	width: 80%;
    	min-width: 100%;
    	margin: 0 auto;
    	overflow: auto
    }
  }

  /* paging end */
  @media screen and (max-width: 48rem) {

    /* banner start */
    .News-bannerbox {
    	width: 100%;
    	min-width: 100%;
    	height: 8rem !important;
    	background-image: url(../assets/news-image/newsbanner.jpg);
    	background-size: 100% 100%
    }

    .News-bannerbox-content {
    	width: 14rem !important;
    	overflow: auto;
    	padding-top: 1.5rem !important;
    	padding-left: 4rem !important
    }

    .Newsbox-contentname {
    	font-size: 1rem;
    	margin-bottom: .5rem;
    	font-family: Source Han Sans SC;
    	color: #fff
    }

    .Newsbannerbox-contenttext {
    	font-size: .1rem;
    	font-family: Source Han Sans SC;
    	font-weight: 400;
    	color: #fff;
    	opacity: 1
    }

    .news-titel {
    	font-size: 1.1rem;
    	margin-top: 0;
    	margin-left: 10px
    }

    .news-titelNEWS {
    	font-size: .1rem !important;
    	border-bottom: .1rem solid #39ab6d;
    	margin-top: 0;
    	width: 4rem;
    	padding-bottom: .3rem;
    	color: #999;
    	margin-left: 10px
    }

    .all-news{
    	font-size: .8rem;
    	font-family: Source Han Sans SC;
    	color: #666;
    	margin-left: 10px
    }

    .el-divider--horizontal {
    	display: block;
    	height: 1px;
    	width: 97%;
    	margin: 24px 12px
    }

    .news-imgbox {
    	margin: 10px auto
    }

    .time {
    	margin-top: 0;
    	font-size: .625rem;
    	margin-left: 10px
    }

    .title {
    	font-size: 1rem;
    	margin: .5rem 0 1.5rem 10px
    }

    .coendncent-news{
    	font-size: .625rem;
    	margin: 0 45px
    }

    .news-contant {
    	width: 80%;
    	min-width: 100%;
    	margin: 0 auto;
    	overflow: auto
    }

    /* newscontent end */
  }
</style>



// WEBPACK FOOTER //
// src/views/NewsCenter.vue